import components from "../components";

// Since CareSource is default, there really shouldn't be anything here
export default {
    ...components,
};
